import { faHammer, faStarExclamation, faSwords, faUsersCrown } from '@awesome.me/kit-24322b77ac/icons/classic/solid';
import { Icon, Paragraph } from '@game/ui';
import type { JSX } from 'react';

import { LoreTooltipFromDictionary } from '@components/LoreToolTip/LoreToolTip';

import './About.less';

const About = (): JSX.Element => {
  return (
    <div className="about">
      <section>
        <Paragraph>Following the great catastrophe, humanity fled Earth and now wanders the stars in search of a new home.</Paragraph>
        <Paragraph>
          As an <LoreTooltipFromDictionary dictionaryKey="Awakened" />, it is up to you to gain knowledge, power and experience, so you may take the
          lead and pioneer the way for the remnants of humanity.
        </Paragraph>
        <Paragraph>Or perhaps not! You decide how to forge your path in this free-to-play, browser-based online role-playing game.</Paragraph>
      </section>
      <section>
        <ul>
          <li>
            <Icon icon={faStarExclamation} /> Both daily and story missions!
          </li>
          <li>
            <Icon icon={faSwords} /> Turn-based combat system with a multitude of skills to allow you to make a truly unique character!
          </li>
          <li>
            <Icon icon={faHammer} /> Craft the most powerful equipment and invest your hard-earned resources.
          </li>
          <li>
            <Icon icon={faUsersCrown} /> See how you measure up on the leaderboards!
          </li>
        </ul>
      </section>
    </div>
  );
};

export default About;
